<template>
  <form @submit.prevent="getList()" method="GET" novalidate>
    <div class="card-body">
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_title"
              >Invoice#</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="invoice_no"
                class="form-control"
                v-model="search.invoice_no"
                placeholder="Invoice No"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="platform"
              >Platform</label
            >
            <div class="col-md-9">
              <multiselect
                name="platform"
                :options="platforms"
                placeholder="Pick Platform"
                :searchable="true"
                :multiple="false"
                v-model="search.platform"
                v-bind:class="{ 'has-error': errors.has('platforms') }"
                class="platform"
              >
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="username"
              >Username</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="username"
                class="form-control"
                v-model="search.username"
                placeholder="User Name"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="name">Name</label>
            <div class="col-md-9">
              <input
                type="text"
                id="name"
                class="form-control"
                v-model="search.name"
                placeholder="Name"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-3 col-form-label" for="pgw_id"
              >Payment Method</label
            >
            <div class="col-md-9">
              <multiselect
                id="pgw_id"
                name="pgw_id"
                :options="pgws.map((pgw) => pgw.id)"
                :custom-label="
                  (opt) => pgws.find((x) => x.id == opt).display_name
                "
                v-bind:class="{ 'has-error': errors.has('pgw_id') }"
                v-validate="'required'"
                v-model="search.pgw_id"
                class="pgw_id"
                placeholder="Select Payment Gateway"
                @select="loadSection($event)"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-3 col-form-label" for="created_at"
              >Created range</label
            >
            <div class="col-md-9">
              <date-picker
                type="datetime"
                input-class="form-control"
                v-model="search.created_at"
                range
                lang="en"
                format="YYYY-MM-DD"
                confirm
                id="created_at"
                value-type="YYYY-MM-DD"
              ></date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="payer_number"
              >Payer#</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="payer_number"
                class="form-control"
                v-model="search.payer_number"
                placeholder="Payer No"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_title"
              >Trx Id</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="trx_id"
                class="form-control"
                v-model="search.trx_id"
                placeholder="Trx Id"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_id"
              >Course</label
            >
            <div class="col-md-9">
              <multiselect
                id="course_id"
                name="course_id"
                :options="Object.keys(courseOptions)"
                :custom-label="(opt) => courseOptions[opt]"
                v-bind:class="{ 'has-error': errors.has('course_id') }"
                v-validate="'required'"
                v-model="search.course_id"
                class="course_id"
                placeholder="Select Course"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_id"
              >Subscription/Bundle</label
            >
            <div class="col-md-9">
              <multiselect
                id="bundle_id"
                name="bundle_id"
                :options="Object.keys(bundleOptions)"
                :custom-label="(opt) => bundleOptions[opt]"
                v-bind:class="{ 'has-error': errors.has('bundle_id') }"
                v-validate="'required'"
                v-model="search.bundle_id"
                class="bundle_id"
                placeholder="Select Bundle"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <button type="submit" class="btn btn-common m-2px">
                <i class="fas fa-search"></i> Search
              </button>
              <button
                type="reset"
                class="btn btn-warning"
                @click="resetFilter()"
              >
                <i class="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
import axios from "axios";

export default {
  props: ["filter"],
  data: () => ({
    search: {},
    platforms: ["android", "ios", "web"],
    pgws: [],
    courseOptions: {},
    bundleOptions: {},
  }),
  components: {
    DatePicker,
  },
  mounted() {
    this.getPaymentGateways();
    this.courseIdOptions();
    this.bundleIdOptions();
    this.search = this.filter;
  },
  methods: {
    courseIdOptions() {
      var _this = this;
      axios
        .get("/get-dropdown-options/8")
        .then((response) => {
          _this.courseOptions = response.data;
          //return response.data;
        })
        .catch((error) => {
          //console.log("error " + error);
          reject(error);
        });
    },
    bundleIdOptions() {
      var _this = this;
      axios
        .get("/get-dropdown-options/11")
        .then((response) => {
          _this.bundleOptions = response.data;
          //return response.data;
        })
        .catch((error) => {
          //console.log("error " + error);
          reject(error);
        });
    },
    getPaymentGateways() {
      this.is_loading = true;
      CommonAPI.paymentGatewayList()
        .then((response) => {
          this.pgws = response.data;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    getList() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.search,
        })
        .catch((err) => {
          //console.log(err);
        });
    },
  },
};
</script>
